import React, {Component} from "react";
import MobileWorkPeriodDataForm from "./mobileWorkPeriodDataForm";
import Input from "../../common/input";
import {get as getShiftPlanningExt} from "../../../services/http/shiftPlanningExtService";
import {deleteWithJWT, getApiUrl, postWithJWT, putWithJWT,} from "../../../services/http/httpService";
import {addDays, dateToString, stringToDate} from "../../../services/dateTimeFormat";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";

class MobileWorkPeriodListForm extends Component {

    constructor(props) {
        super();
    }

    state = {
        selectedPersonId: 0,
        dataList: [],
        date: dateToString(new Date(), "YYYYMMDD"),
        showModal: false,

    };

    data = {
        dbId: 0,
        personId: 0,
        startDate: "",
        endDate: "",
        projectDbId: 0,
        orderDbId: 0,
        orderItemDbId: 0,
        costUnitDbId: 0,
        machineDbId: 0,
        workprocessDbId: 0,
        workplaceDbId: 0
    };
    personsMap = {};
    daysMap = {};

    absenceMap = {};
    projectMap = {};
    orderMap = {};
    orderItemMap = {};
    costUnitMap = {};
    machineMap = {};
    workplaceMap = {};
    workprocessMap = {};


    absencesMap = [];

    componentDidMount = async () => {
        const {date} = this.state;
        await this.onRefresh(date);
    };

    onRefresh = async (date) => {
        const request = await getShiftPlanningExt(
            this.props.credentials,
            getApiUrl() +
            "/" +
            "secClockworkWorkPeriod" +
            "?personId=" + this.state.selectedPersonId +
            "&startDate=" + date +
            "&endDate=" + date
        );

        this.personsMap = {...request.data.data.personsMap};
        this.daysMap = {...request.data.data.daysMap};

        this.absencesMap = {...request.data.data.absencesMap};
        this.projectsMap = {...request.data.data.projectsMap};
        this.ordersMap = {...request.data.data.ordersMap};
        this.orderItemsMap = {...request.data.data.orderItemsMap};
        this.costUnitsMap = {...request.data.data.costUnitsMap};
        this.machinesMap = {...request.data.data.machinesMap};
        this.workplacesMap = {...request.data.data.workplacesMap};
        this.workprocessesMap = {...request.data.data.workprocessesMap};

        this.createDataList(date);
    };

    onChangeDate = ({currentTarget: input}) => {
        const {date} = this.state;
        this.onRefresh(
            dateToString(stringToDate(input.value, "YYYY-MM-DD"), "YYYYMMDD")
        );
    };

    onOneDayBefore = () => {
        const {date} = this.state;
        const newDate = dateToString(addDays(stringToDate(date, "YYYYMMDD"), -1), "YYYYMMDD");
        this.onRefresh(newDate);
    };

    onOneDayAfter = () => {
        const {date} = this.state;
        const newDate = dateToString(addDays(stringToDate(date, "YYYYMMDD"), 1), "YYYYMMDD");
        this.onRefresh(newDate);
    };

    onChangePerson = ({currentTarget: input}) => {
        // const { date } = this.state;
        // this.onRefresh(
        //     dateToString(stringToDate(input.value, "YYYY-MM-DD"), "YYYYMMDD")
        // );
    };

    onChangeStartDate = ({value}) => {
        const {date} = this.state
        this.data.startDate = dateToString(stringToDate(date + value, "YYYYMMDDHH:mm"), "YYYYMMDDHHmm")
        this.setState({});
    }
    onChangeEndDate = ({value}) => {
        const {date} = this.state
        this.data.endDate = dateToString(stringToDate(date + value, "YYYYMMDDHH:mm"), "YYYYMMDDHHmm")
        this.setState({});
    }
    onChangeProject = (dbId) => {
        this.data.projectDbId = dbId;
        this.setState({});
    }
    onChangeOrder = (dbId) => {
        this.data.orderDbId = dbId;
        this.setState({});
    }
    onChangeOrderItem = (dbId) => {
        this.data.orderItemDbId = dbId;
        this.setState({});
    }
    onChangeCostUnit = (dbId) => {
        this.data.costUnitDbId = dbId;
        this.setState({});
    }
    onChangeMachine = (dbId) => {
        this.data.machineDbId = dbId;
        this.setState({});
    }
    onChangeWorkplace = (dbId) => {
        this.data.workplaceDbId = dbId;
        this.setState({});
    }
    onChangeWorkprocess = (dbId) => {
        this.data.workprocessDbId = dbId;
        this.setState({});
    }
    onChangeComment = ({currentTarget: input}) => {
        this.data.comment = input.value;
        this.setState({});
    }

    onSaveData = async () => {
        const {date} = this.state;
        const {data} = this;
        if (data.dbId === 0) {
            const request = await postWithJWT(
                this.props.credentials,
                getApiUrl() + "/secClockworkWorkPeriod",
                {...data}
            );
        } else {
            const request = await putWithJWT(
                this.props.credentials,
                getApiUrl() + "/secClockworkWorkPeriod" + "?" +
                "dbId=" + data.dbId,
                {...data}
            );
        }
        this.onRefresh(date)
    };

    onDeleteData = async () => {
        const {date} = this.state;
        const {data} = this;
        const request = await deleteWithJWT(
            this.props.credentials,
            getApiUrl() + "/secClockworkWorkPeriod" + "?" +
            "dbId=" + data.dbId
        );
        this.onRefresh(date)
    };

    createDataList = (date) => {
        const {selectedPersonId} = this.state;
        const {personsMap, daysMap} = this;

        const personsMapObject = Object.entries(personsMap);
        const daysMapObject = Object.entries(daysMap);
        const dataList = [];
        let newSelectedPersonId = selectedPersonId;

        if (selectedPersonId === 0) {
            if (personsMapObject.length > 0) {
                newSelectedPersonId = personsMapObject[0][0];
            }
        }

        if (daysMap[date]) {

            dataList.push({
                clickable: false,
                text: "GEPLANTE ZEITEN"
            });

            for (const day of daysMap[date].plannedDataList) {

                const start = dateToString(stringToDate(day.start, "YYYYMMDDHHmm"), "HH:mm")
                const end = dateToString(stringToDate(day.end, "YYYYMMDDHHmm"), "HH:mm")

                dataList.push({
                    text: start + " - " + end
                });

                dataList.push({
                    text: "."
                });

            }

            if (daysMap[date].absencePlanningList && daysMap[date].absencePlanningList.length > 0) {

                dataList.push({
                    text: "ABWESENHEIT"
                });

                for (const day of daysMap[date].absencePlanningList) {

                    dataList.push({
                        text: day.text
                    });

                }

                dataList.push({
                    text: "."
                });

            }


            dataList.push({
                add: true,
                dbId: 0,
                personDbId: newSelectedPersonId,
                startDate: date + "0800",
                endDate: date + "0830",
                text: "ERFASSTE ZEITEN +"
            });

            for (const day of daysMap[date].workPeriodList) {

                const start = dateToString(stringToDate(day.start, "YYYYMMDDHHmm"), "HH:mm")
                const end = dateToString(stringToDate(day.end, "YYYYMMDDHHmm"), "HH:mm")

                dataList.push({
                    update: true,
                    dbId: day.dbId,
                    personDbId: newSelectedPersonId,
                    startDate: day.start,
                    endDate: day.end,
                    projectDbId: day.projectDbId,
                    orderDbId: day.orderDbId,
                    orderitemDbId: day.orderitemDbId,
                    costUnitDbId: day.costUnitDbId,
                    machineDbId: day.machineDbId,
                    workplaceDbId: day.workplaceDbId,
                    workprocessDbId: day.workprocessDbId,
                    text: start + " - " + end
                });

                if (day.projectDbId) {
                    dataList.push({
                        text: this.projectsMap[day.projectDbId].name
                    });
                }

                if (day.orderDbId) {
                    dataList.push({
                        text: this.ordersMap[day.orderDbId].name
                    });
                }

                if (day.orderItemDbId) {
                    dataList.push({
                        text: this.orderItemsMap[day.orderItemDbId].name
                    });
                }

                if (day.costUnitDbId) {
                    dataList.push({
                        text: this.costUnitsMap[day.costUnitDbId].name
                    });
                }

                if (day.machineDbId) {
                    dataList.push({
                        text: this.machinesMap[day.machineDbId].name
                    });
                }

                if (day.workplaceDbId) {
                    dataList.push({
                        text: this.workplacesMap[day.workplaceDbId].name
                    });
                }

                if (day.workprocessDbId) {
                    dataList.push({
                        text: this.workprocessesMap[day.workprocessDbId].name
                    });
                }

                dataList.push({
                    text: "."
                });
            }

        }


        this.setState({dataList, selectedPersonId: newSelectedPersonId, date, showModal: false});

    }

    renderPersonHeader = (personId, onChangePerson) => { // }, onChangeDate) => {
        const {personsMap} = this;
        return (
            <div className="d-flex justify-content-center">
                <h4>{personsMap[personId].surname}</h4>
                {/*<Input*/}
                {/*    name={"personId"}*/}
                {/*    value={personsMap[personId].surname}*/}
                {/*    type={"text"}*/}
                {/*    onChange={onChangePerson}*/}
                {/*/>*/}
            </div>
        );
    }

    renderDateHeader = (date, onChangeDate) => {
        return (
            <div className="d-flex justify-content-center">
                <button
                    className="btn light btn-sm"
                    onClick={this.onOneDayBefore}
                >
                    {"<= 1 Tag"}
                </button>
                <Input
                    name={"date"}
                    value={dateToString(
                        stringToDate(date, "YYYYMMDD"),
                        "YYYY-MM-DD"
                    )}
                    type={"date"}
                    onChange={onChangeDate}
                />
                <button
                    className="btn light btn-sm"
                    onClick={this.onOneDayAfter}
                >
                    {"1 Tag =>"}
                </button>
            </div>
        );
    }

    onOpenModal = () => {
        this.setState({showModal: true});
    };

    onCloseModal = () => {
        this.setState({showModal: false});
    };

    onRowClick = (state, rowInfo, column, instance) => {
        return {
            onClick: e => {
                if (rowInfo.row._original.add) {
                    this.data = {...rowInfo.row._original};
                    this.data.dbId = 0;
                    this.onOpenModal();
                } else if (rowInfo.row._original.update) {
                    this.data = {...rowInfo.row._original};
                    this.onOpenModal();
                }
            }
        }
    }

    MODAL_STYLES = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, .5)",
        },
        content: {
            position: "absolute",
            top: "40px",
            left: "40px",
            right: "40px",
            height: "700px",
            border: "1px solid #ccc",
            background: "#fff",
            overflow: "show",
            WebkitOverflowScrolling: "touch",
            borderRadius: "4px",
            outline: "none",
            padding: "20px",
        },
    };

    render = () => {
        const {
            selectedPersonId,
            dataList,
            date,
            showModal
        } = this.state;
        const {
            absencesMap,
            projectsMap,
            ordersMap,
            orderItemsMap,
            costUnitsMap,
            machinesMap,
            workplacesMap,
            workprocessesMap,
            MODAL_STYLES,
            onSaveData,
            onDeleteData,
            onCloseModal,
            onChangeDate,
            onChangePerson,
            renderPersonHeader,
            renderDateHeader,
            onChangeStartDate,
            onChangeEndDate,
            onChangeProject,
            onChangeOrder,
            onChangeOrderItem,
            onChangeCostUnit,
            onChangeMachine,
            onChangeWorkplace,
            onChangeWorkprocess,
            onChangeComment,
        } = this;

        if (selectedPersonId <= 0)
            return (<React.Fragment></React.Fragment>);

        let columns = [];

        const ReactTableFixedColumns = withFixedColumns(ReactTable);

        const tdStyle = (state, rowInfo, column, instance) => {
            return {
                style: {
                    // fontSize: "x-small",
                    padding: "2px 2px",
                    margin: "0",
                    fontSize: rowInfo.row._original.add || rowInfo.row._original.update ? "xx-large" : "large"
                }
            }
        };

        columns.push({
            Header: (
                <React.Fragment>
                    {renderPersonHeader(selectedPersonId, onChangePerson)}
                    {renderDateHeader(date, onChangeDate)}
                </React.Fragment>
            ),
            columns: [],
        });

        columns[0].columns.push({
            // Header: "Name",
            accessor: "text",
            // fixed: "left",
            // Cell: (cellInfo) => this.renderName(cellInfo),
        });

        return (
            <React.Fragment>
                <MobileWorkPeriodDataForm
                    absencesMap={absencesMap}
                    projectsMap={projectsMap}
                    ordersMap={ordersMap}
                    orderItemsMap={orderItemsMap}
                    costUnitsMap={costUnitsMap}
                    machinesMap={machinesMap}
                    workplacesMap={workplacesMap}
                    workprocessesMap={workprocessesMap}
                    showModal={showModal}
                    contentLabel="MobileShiftPlanningDataForm"
                    style={MODAL_STYLES}
                    ariaHideApp={false}
                    handleCloseModal={onCloseModal}
                    handleSave={onSaveData}
                    handleDelete={onDeleteData}
                    data={this.data}
                    handleChangeStartDate={onChangeStartDate}
                    handleChangeEndDate={onChangeEndDate}
                    handleChangeProject={onChangeProject}
                    handleChangeOrder={onChangeOrder}
                    handleChangeOrderItem={onChangeOrderItem}
                    handleChangeCostUnit={onChangeCostUnit}
                    handleChangeMachine={onChangeMachine}
                    handleChangeWorkplace={onChangeWorkplace}
                    handleChangeWorkprocess={onChangeWorkprocess}
                    handleChangeComment={onChangeComment}
                />
                {!this.state.showModal && (
                    <ReactTableFixedColumns
                        columns={columns}
                        data={dataList}
                        defaultPageSize={dataList.length}
                        showPagination={false}
                        // getTheadThProps={thStyle}
                        getTdProps={tdStyle}
                        getTrProps={this.onRowClick}
                        // style={{ height: window.innerHeight }}
                    />
                )}
            </React.Fragment>
        );
    }
}

export default MobileWorkPeriodListForm;
